// ═══════════════════════════════════════════════════════════════════
//  modules/projets/NewTaskModal.js
//  NewTaskModal
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { categoriesForCategory } from "../chat/utils";

export function NewTaskModal({ token, projectId, defaultCategory, onClose, onCreated }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState(defaultCategory || "plugins");
  const [priority, setPriority] = useState("moyenne");
  const [steps, setSteps] = useState([""]);
  const [saving, setSaving] = useState(false);

  const updateStep = (i, val) => { const copy = [...steps]; copy[i] = val; setSteps(copy); };
  const addStep = () => setSteps([...steps, ""]);
  const removeStep = (i) => setSteps(steps.filter((_, idx) => idx !== i));

  const handleCreate = async () => {
    if (!title.trim()) return;
    setSaving(true);
    await fetch(`${API_BASE}/api/projects/${projectId}/tasks`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ title, description, category, priority, steps: steps.filter((s) => s.trim()) }),
    });
    setSaving(false);
    onCreated();
    onClose();
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}
      onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: 28, width: 480, maxHeight: "85vh", overflowY: "auto", display: "flex", flexDirection: "column", gap: 16 }}>
        <h3 style={{ color: THEME.text, fontSize: 18, fontWeight: 700, margin: 0 }}>➕ Nouvelle tâche</h3>
        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Titre de la tâche"
          style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 14, outline: "none" }} />
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Description (optionnel)" rows={3}
          style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 13, outline: "none", resize: "vertical", fontFamily: "inherit" }} />
        <div style={{ display: "flex", gap: 10 }}>
          <select value={category} onChange={(e) => setCategory(e.target.value)}
            style={{ flex: 1, background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 13 }}>
            {categoriesForCategory(category).map(([key, val]) => <option key={key} value={key}>{val.label}</option>)}
          </select>
          <select value={priority} onChange={(e) => setPriority(e.target.value)}
            style={{ flex: 1, background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 13 }}>
            <option value="haute">Priorité haute</option>
            <option value="moyenne">Priorité moyenne</option>
            <option value="basse">Priorité basse</option>
          </select>
        </div>
        <div>
          <label style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 600 }}>ÉTAPES (optionnel)</label>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 6 }}>
            {steps.map((s, i) => (
              <div key={i} style={{ display: "flex", gap: 6 }}>
                <input value={s} onChange={(e) => updateStep(i, e.target.value)} placeholder={`Étape ${i + 1}`}
                  style={{ flex: 1, background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 6, padding: "7px 10px", color: THEME.text, fontSize: 13, outline: "none" }} />
                {steps.length > 1 && <button onClick={() => removeStep(i)} style={{ background: "transparent", border: "none", color: THEME.red, cursor: "pointer", fontSize: 16 }}>×</button>}
              </div>
            ))}
            <button onClick={addStep} style={{ background: "transparent", border: `1px dashed ${THEME.border}`, color: THEME.textMuted, borderRadius: 6, padding: "6px", cursor: "pointer", fontSize: 12 }}>+ Ajouter une étape</button>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
          <button onClick={onClose} style={{ background: "transparent", border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 8, padding: "9px 18px", cursor: "pointer", fontSize: 13 }}>Annuler</button>
          <button onClick={handleCreate} disabled={saving || !title.trim()}
            style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 8, padding: "9px 20px", cursor: "pointer", fontSize: 13, fontWeight: 700, opacity: saving ? 0.6 : 1 }}>
            {saving ? "Création..." : "Créer"}
          </button>
        </div>
      </div>
    </div>
  );
}
